<template>
  <router-view/>
</template>

<script>
export default {
  mounted() {
    // 检测并重置翻译插件的样式
    const immersivePopup = document.getElementById('immersive-translate-browser-popup')
    if (immersivePopup) {
      immersivePopup.style.all = 'unset'
      immersivePopup.style.display = 'none'
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

@import "@/assets/layout/main.css";
@import "@/assets/styles/main.css";
@import "@/assets/styles/globel.css";
</style>
